'use client'

import { Box, Container, Typography, Chip } from '@mui/material';
import JacActivity from '@/components/ui/csr/JacActivity';
import { useTranslations } from 'next-intl';

export default function CsrContent() {
    const t = useTranslations('CsrPage.CsrContent');
    const tSchema = useTranslations('CsrPage.schema');

    const ACCENT = '#F15859';

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            {/* Header */}
            <Box sx={{ backgroundColor: '#132c4b', color: 'white', py: { xs: 8, md: 8 }, mb: { xs: 8, md: 10 } }}>
                <Container maxWidth="lg">
                    <Chip
                        label={t('chip')}
                        sx={{
                            bgcolor: ACCENT,
                            color: "white",
                            fontWeight: 700,
                            mb: 3,
                        }}
                    />
                    <Typography
                        component="h1"
                        sx={{
                            fontSize: { xs: "24px", md: "36px" },
                            fontWeight: 800,
                            lineHeight: 1.1,
                            mb: 2,
                        }}
                    >
                        {t('title')}
                    </Typography>
                    <Typography
                        sx={{
                            color: "rgba(255,255,255)",
                            mb: 2,
                            maxWidth: "80%",
                            fontSize: "14px",
                        }}
                    >
                        {t('description')}
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="lg">
                <JacActivity />
            </Container>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "SpaciaNet Japan (AirXpress)",
                        "url": "https://airxpress.jp",
                        "areaServed": ["Japan", "Cambodia"],
                        "sameAs": [
                            "https://www.facebook.com/spacianet.co.jp/",
                            "https://www.instagram.com/spacianet__airxpress",
                            "https://x.com/nairxpress",
                            "https://www.tiktok.com/@spacianet__airxpress",
                        ],
                        "description": tSchema('description')
                    })
                }}
            />

        </Box>
    );
}
